
    var riot = require('riot')
    //src: starling/src/tags/modal-share/panel-invite.html
riot.tag2('panel-invite',
  '<div if="{!this.allowMoreInvites()}" class="panel-invite_alert"> You\'ve reached the maximum number of people this map can be shared with.<br> <span>Try <a href="#" onclick="{goToPanel}">sending a link</a> if you need to share with a larger audience.</span> </div> <div if="{this.allowMoreInvites()}" class="panel-invite_form"> <input ref="shareAccessEmailInput" type="text" class="panel-invite_input" placeholder="Enter names or emails…" onkeydown="{handleShareAccessAddInput}" onclick="{handleShareAccessAutocomplete}" onkeyup="{handleShareAccessAutocomplete}" autocomplete="new-password"> <div class="panel-invite_menu"> <button class="panel-invite_menu_button" style="background-color: var(--gray1)" onclick="{togglePermissionMenu}" onmousedown="{preventFocus}"> Can {permission} <svg class="panel-invite_menu_button_icon"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> <div ref="permissionMenu" class="floating-menu floating-menu--bottom floating-menu--right floating-menu--small floating-menu--hidden"> <ul class="floating-menu_list"> <li class="floating-menu_item {permission !== \'view\' && \'floating-menu_item--iconless\'}" onclick="{setPermission.bind(this, \'view\')}"> <svg if="{permission === \'view\'}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label"> Can view </span> </li> <li class="floating-menu_item {permission !== \'comment\' && \'floating-menu_item--iconless\'}" onclick="{setPermission.bind(this, \'comment\')}"> <svg if="{permission === \'comment\'}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label"> Can comment </span> </li> <li class="floating-menu_item {permission !== \'edit\' && \'floating-menu_item--iconless\'}" onclick="{setPermission.bind(this, \'edit\')}"> <svg if="{permission === \'edit\'}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label"> Can edit </span> </li> </ul> </div> </div> <autocomplete-contacts canvas="{canvas}"></autocomplete-contacts> </div> <div if="{this.showInviteLimitExceededError}" class="panel-invite_alert"> You\'ve reached the limit of invites you can send for now<br> <span>Try <a href="#" onclick="{goToPanel}">sending a link</a> if you need to share with a larger audience.</span> </div> <virtual if="{collaboratorsPending && collaboratorsPending.length}"> <div class="panel-invite_title">Access request…</div> <ul class="shared-access_list mrgn-b-24" onwheel="{handleScroll}"> <li each="{collab in collaboratorsPending}" class="shared-access_entry"> <img class="avatar shared-access_avatar" riot-src="{collab.avatar_url || \'/images/avatar.png\'}" alt="{collab.display_name} avatar"> <span class="shared-access_title">{collab.display_name}</span> <button class="Button Button--Outlined Button--Small" onclick="{rejectMapAccess}"> Reject </button> <button class="Button Button--Outlined Button--Small Button--Primary mrgn-l-8" onmousedown="{toggleAcceptRequestAccessMenu.bind(this, collab)}"> <span class="Button__Label">Accept</span> <svg class="Button__Icon Button__Icon--Caret"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> </li> </ul> </virtual> <div class="shared-access_label">Shared with…</div> <ul class="shared-access_list" onwheel="{handleScroll}"> <li class="shared-access_entry"> <svg class="avatar shared-access_avatar shared-access_avatar--icon"> <use xlink:href="#supervisor-account-icon"></use> </svg> <span class="shared-access_title shared-access_title--light"> <span if="{viewLinkAvailable()}"> Anyone with a link can <b>view</b> </span> <span if="{!viewLinkAvailable() && !isInWorkspace()}"> View link is <b>off</b> </span> <span if="{!viewLinkAvailable() && isInWorkspace()}"> Only members of the workspace can <b>view</b> or <b>edit</b> </span> </span> <button class="panel-invite_menu_button" onclick="{goToPanel}">Manage</button> </li> <li class="shared-access_entry" if="{!window.user || canvas.people.owner.id !== window.user.id}"> <img class="avatar shared-access_avatar" riot-src="{canvas.people.owner.avatar_url || \'/images/avatar.png\'}" alt="{canvas.people.owner.display_name} avatar"> <span class="shared-access_title">{canvas.people.owner.display_name}</span> <button class="panel-invite_menu_button" disabled>Owner</button> </li> <li class="shared-access_entry" if="{showCurrentUserRole()}"> <img class="avatar shared-access_avatar" riot-src="{window.user.avatar_url || \'/images/avatar.png\'}" alt="{window.user.display_name} avatar"> <span class="shared-access_title">{window.user.display_name} (You)</span> <button class="panel-invite_menu_button" disabled>{getCurrentUserPermission()}</button> </li> <li each="{collab in getSharedWithUsers()}" class="shared-access_entry"> <img class="avatar shared-access_avatar" riot-src="{collab.user.avatar_url || \'/images/avatar.png\'}" alt="{collab.user.display_name} avatar"> <span class="shared-access_title">{collab.user.display_name}</span> <button class="panel-invite_menu_button" disabled="{!canChangePermission(collab)}" onmousedown="{toggleEditShareUserAccessMenu.bind(this, collab)}"> Can {collab.permission} <svg class="panel-invite_menu_button_icon"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> </li> <li each="{collab in invitedUsers}" class="shared-access_entry shared-access_entry--invitation"> <img class="avatar shared-access_avatar" src="/images/avatar.png" alt="{collab.user.email} avatar"> <span class="shared-access_title">{collab.user.email}</span> <span class="shared-access_invite-status">Invite sent</span> <button class="panel-invite_menu_button" disabled="{!canChangePermission(collab)}" onmousedown="{toggleEditShareUserAccessMenu.bind(this, collab)}"> Can {collab.permission} <svg class="panel-invite_menu_button_icon"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> </li> </ul>',
  '',
  'class="modal-share_panel panel-invite" onclick="{hidePermissionMenu}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var EmailAddressParser = require('email-addresses');

var _opts = opts,
    canvas = _opts.canvas;

canvas.inviteSharePanel = this;

this.permission = 'edit';
this.sharedWithUsers = []; // invited users with accounts
this.invitedUsers = []; // invites without accounts
this.contacts = []; // contacts that have not been shared with
this.allContacts = [];
this.collaboratorsPending = [];
this.showInviteLimitExceededError = false;

this.on('mount', function () {
  canvas.operation.on('operation-update-map-share-settings', function () {
    _this.update();
  });

  if (window.shared_users || window.invited_users) {
    _this.sharedWithUsers = window.shared_users || [];
    _this.invitedUsers = window.invited_users || [];
    _this.update();
  }

  _this.loadContacts();
});

this.getSharedWithUsers = function () {
  if (!window.user) return _this.sharedWithUsers;
  return _this.sharedWithUsers.filter(function (c) {
    return c.user && c.user.id !== window.user.id;
  });
};

this.allowMoreInvites = function () {
  // cap the number of invited users to 100
  if (_this.sharedWithUsers.length + _this.invitedUsers.length >= 100) return false;
  return true;
};

this.inviteLimitExceededError = function () {
  _this.showInviteLimitExceededError = true;
  _this.update();
};

this.handleShareAccessAddInput = function (e) {
  var ENTER = _constants.KEY_CODES.ENTER,
      DOWN_ARROW = _constants.KEY_CODES.DOWN_ARROW,
      UP_ARROW = _constants.KEY_CODES.UP_ARROW;

  if (e.keyCode === ENTER) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    var selectedResult = canvas.autocompleteContactsTag.getSelectedResult();

    if (selectedResult) {
      _this.handleAutocompleteSubmission(selectedResult);
      canvas.autocompleteContactsTag.hide();
      return;
    }

    _this.saveShareAccessInputs();
    return;
  } else if (e.keyCode == DOWN_ARROW) {
    if (canvas.autocompleteContactsTag.isOpen) {
      canvas.autocompleteContactsTag.incrementSelected(1);
      e.stopPropagation();
      e.preventDefault();
    }
  } else if (e.keyCode == UP_ARROW) {
    if (canvas.autocompleteContactsTag.isOpen) {
      canvas.autocompleteContactsTag.incrementSelected(-1);
      e.stopPropagation();
      e.preventDefault();
    }
  }
};

this.handleShareAccessAutocomplete = function (e) {
  var ENTER = _constants.KEY_CODES.ENTER,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  if (e.keyCode === ENTER) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    canvas.autocompleteContactsTag.hide();
    return;
  }

  if (e.keyCode == ESCAPE) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    canvas.autocompleteContactsTag.hide();
    return;
  }

  var query = _this.refs.shareAccessEmailInput.value.trim();

  if (!query) {
    canvas.autocompleteContactsTag.hide();
    return;
  }

  canvas.autocompleteContactsTag.showResults(query);
};

this.saveShareAccessInputs = function () {
  var permission = _this.permission;

  var txt = _this.refs.shareAccessEmailInput.value;
  var emails = _this.extractEmails(txt);

  _this.sendMapsToUsers({ emails: emails, permission: permission });
};

this.sendMapsToUsers = function (_ref) {
  var emails = _ref.emails,
      permission = _ref.permission;

  if (!emails || !emails.length) return;

  var messages = [];

  for (var _iterator = emails, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var email = _ref2;

    messages.push(canvas.operation.messages.shareMapWithUser({
      email: email,
      permission: permission
    }));
  }

  canvas.operation.batchOperation({
    messages: messages,
    undoable: false,
    onFailure: function onFailure(err) {
      console.log('sendMapsToUsers failure: ' + err);
    },
    onSuccess: function onSuccess(msg) {
      if (!msg.messages || !msg.messages.length) return;

      var errors = msg.messages.filter(function (m) {
        return m.errorMessage;
      }).map(function (m) {
        return m.errorMessage;
      });
      var sharedWithNewUsers = msg.messages.filter(function (m) {
        return m.sentToUser && m.sentToUser.user;
      }).map(function (m) {
        return m.sentToUser;
      });
      if (errors && errors[0] === 'invite limit exceeded') {
        _this.inviteLimitExceededError();
      } else {
        _this.showInviteLimitExceededError = false;
      }
      _this.updateSharedWithUsers(sharedWithNewUsers);
      _this.clearInput();
    }
  });
};

this.updateSharedWithUsers = function (collabs) {
  var _loop = function _loop() {
    if (_isArray2) {
      if (_i2 >= _iterator2.length) return 'break';
      _ref3 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) return 'break';
      _ref3 = _i2.value;
    }

    var collab = _ref3;

    if (collab.permission === 'removed') {
      if (collab.userId) {
        _this.sharedWithUsers = _this.sharedWithUsers.filter(function (c) {
          return c.userId !== collab.userId;
        });
      } else if (collab.inviteId) {
        _this.invitedUsers = _this.invitedUsers.filter(function (c) {
          return c.inviteId !== collab.inviteId;
        });
      }
      return 'continue';
    }

    if (collab.userId) {
      if (_this.sharedWithUsers.find(function (c) {
        return c.userId === collab.userId;
      })) return 'continue';
      _this.sharedWithUsers.unshift(collab);
    }

    if (collab.inviteId) {
      if (_this.invitedUsers.find(function (c) {
        return c.inviteId === collab.inviteId;
      })) return 'continue';
      _this.invitedUsers.unshift(collab);
    }
  };

  _loop2: for (var _iterator2 = collabs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref3;

    var _ret = _loop();

    switch (_ret) {
      case 'break':
        break _loop2;

      case 'continue':
        continue;}
  }

  _this.updateContacts();
  _this.update();
};

/*
  filter the contacts list used for autosuggest so that
  we don't suggest users that are already added
*/
this.updateContacts = function () {
  var filtered = [];

  var _loop3 = function _loop3() {
    if (_isArray3) {
      if (_i3 >= _iterator3.length) return 'break';
      _ref4 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) return 'break';
      _ref4 = _i3.value;
    }

    var u = _ref4;

    if (_this.invitedUsers.find(function (c) {
      return c.user.email === u.email;
    })) return 'continue';
    if (_this.sharedWithUsers.find(function (c) {
      return c.userId === u.id;
    })) return 'continue';
    filtered.push(u);
  };

  _loop4: for (var _iterator3 = _this.allContacts, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref4;

    var _ret2 = _loop3();

    switch (_ret2) {
      case 'break':
        break _loop4;

      case 'continue':
        continue;}
  }

  _this.contacts = filtered;

  canvas.autocompleteContactsTag.setContacts(_this.contacts);
  canvas.autocompleteContactsTag.setCallback(_this.handleAutocompleteSubmission);
};

this.loadContacts = function () {
  if (_this.contacts.length) return;

  $.ajax({
    url: '/api/user/contacts',
    success: function success(data) {
      if (data && data.contacts) {
        _this.allContacts = data.contacts;
        _this.updateContacts();
      }
    }
  });
};

this.handleAutocompleteSubmission = function (user) {
  // TODO: render as a pill....
  _this.refs.shareAccessEmailInput.value = user.email;
};

/*
  pull emails out of a block of command delimited emails and whatever other junk might be in there too...
*/
this.extractEmails = function (txt) {
  var list = EmailAddressParser.parseAddressList(txt);

  if (list) {
    return list.map(function (e) {
      return e.address;
    });
  }
};

this.showPermission = function (collab) {
  if (collab.permission === 'edit') {
    return 'can edit';
  } else if (collab.permission === 'comment') {
    return 'can comment';
  } else if (collab.permission === 'view') {
    return 'can view';
  }
};

this.toggleEditShareUserAccessMenu = function (collab, e) {
  if (!_this.canChangePermission(collab)) return;
  e.stopPropagation();
  var editShareUserAccessMenu = canvas.editShareUserAccessMenu;

  if (editShareUserAccessMenu.isOpenForUser(collab)) {
    editShareUserAccessMenu.hide();
  } else {
    editShareUserAccessMenu.summon({
      collab: collab,
      referenceEl: e.target
    });
  }
};

this.toggleAcceptRequestAccessMenu = function (collab, e) {
  var acceptRequestAccessMenu = canvas.acceptRequestAccessMenu;

  e.stopPropagation();

  if (acceptRequestAccessMenu.isOpenForUser(collab)) {
    acceptRequestAccessMenu.hide();
  } else {
    acceptRequestAccessMenu.summon({ collab: collab, referenceEl: e.target.closest('button') });
  }
};

this.canChangePermission = function (collab) {
  // users can't change their own permission
  if (window.user.id && collab.userId && collab.userId === window.user.id) return false;
  // user can't change the owner's permission
  if (collab.userId && collab.userId === canvas.people.owner.id) return false;
  return true;
};

this.handleScroll = function (event) {
  return event.stopPropagation();
};

this.goToPanel = function () {
  _this.parent.setOpenTab('share-url');
};

this.isInWorkspace = function () {
  if (window.workspace) return true;
};

this.viewLinkAvailable = function () {
  if (window.workspace) return window.workspace.enablePublicLinkSharing && canvas.access.enablePublicViewLink;
  return canvas.access.enablePublicViewLink;
};

this.setPermission = function (permission) {
  Object.assign(_this, { permission: permission });
  _this.update();
};

this.showPermissionMenu = function () {
  _this.isPermissionMenuVisible = true;
  _this.refs.permissionMenu.classList.remove('floating-menu--hidden');
};

this.hidePermissionMenu = function () {
  _this.isPermissionMenuVisible = false;
  _this.refs.permissionMenu.classList.add('floating-menu--hidden');
};

this.togglePermissionMenu = function (event) {
  event.stopPropagation();
  event.target.blur();

  if (_this.isPermissionMenuVisible) {
    _this.hidePermissionMenu();
  } else {
    _this.showPermissionMenu();
  }
};

this.preventFocus = function (e) {
  e.preventDefault();
};

this.clearInput = function () {
  _this.refs.shareAccessEmailInput.value = '';
};

this.showCurrentUserRole = function () {
  if (!window.user) return false;
  return true;
};

this.getCurrentUserPermission = function () {
  if (canvas.store.access.role === 'admin') return 'Admin';
  if (canvas.store.access.role === 'owner') return 'Owner';
  return 'Can ' + canvas.store.access.permission;
};

this.rejectMapAccess = function (_ref5) {
  var item = _ref5.item;
  var collaboratorsPending = _this.collaboratorsPending;
  var collab = item.collab;
  var userId = collab.id;

  $.post('/api/maps/' + window.access.publicIdentifier + '/reject-access', { userId: userId }).done(function () {
    var filteredCollaborators = collaboratorsPending.filter(function (pending) {
      return pending !== collab;
    });

    _this.parent.update({ collaboratorsPending: filteredCollaborators });
    _this.update({ collaboratorsPending: filteredCollaborators });
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('panel-invite')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-share/panel-invite.html
// module id = 762
// module chunks = 0